'use client';
import { useState } from 'react';
import { useInterval } from '../useInterval/useInterval.js';

const useTime = (refreshRate = 1000)=>{
    const [time, setTime] = useState(Date.now());
    useInterval(()=>setTime(Date.now()), refreshRate);
    return time;
};

export { useTime };
//# sourceMappingURL=useTime.js.map
